import React, { useEffect, useState } from "react";
import { Outlet, NavLink } from "react-router-dom";
import Navbar3 from "../Navbars/Navbar3";
import FooterPages from "../Footer/FooterPages";
import { useSelector } from "react-redux";
import ChatBot from "./ChatBot/ChatBot_API_v2";

const COCKPIT_SECTIONS = [
  {
    label: "Brand Sales Performance",
    to: "/cockpit/sales-performance",
    icon: "fas fa-chart-line",
  },
  {
    label: "Media Spends Vs Contribution",
    to: "/cockpit/media-sales-spends",
    icon: "fas fa-money-bill-wave",
  },
  {
    label: "Media Wise ROI",
    to: "/cockpit/media-roi",
    icon: "fas fa-chart-bar",
  },
  {
    label: "Region Wise Detail",
    to: "/cockpit/region-detail",
    icon: "fas fa-globe",
  },
];

const IndexPage = ({ theme = "light", toggleTheme }) => {
  const [collapsed, setCollapsed] = useState(false);

  const { salesData, loading } = useSelector((state) => state.dashboard || {});
  const brandName = salesData?.brand || "Brand";
  const currentFY = salesData?.current_fy || "Current FY";
  const previousFY = salesData?.previous_fy || "Previous FY";
  const dataTillMonth = salesData?.data_present_till;

  useEffect(() => {
    document.body.classList.remove("light-theme", "dark-theme");
    document.body.classList.add(`${theme}-theme`);
    return () => document.body.classList.remove("light-theme", "dark-theme");
  }, [theme]);

  return (
    <>
      <div className={`rr-app-shell ${theme}-theme`}>
        <Navbar3
          theme={theme}
          toggleTheme={toggleTheme}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        <div
          className="rr-app-main"
          data-collapsed={collapsed ? "true" : "false"}
        >
          <div className="dashboard-layout d-flex flex-column">
            <div className="cockpit-header">
              <div
                className={`quick-links-strip ${loading ? "disabled-links" : ""}`}
              >
                <div className="quick-links-inner">
                  <div className="quick-links-list">
                    {COCKPIT_SECTIONS.map((item) => (
                      <NavLink
                        key={item.to}
                        to={loading ? "#" : item.to}
                        onClick={(e) => loading && e.preventDefault()}
                        className={({ isActive }) =>
                          `quick-link-chip ${isActive ? "active-quick-link" : ""} ${
                            loading ? "link-disabled" : ""
                          }`
                        }
                      >
                        <i className={item.icon}></i>
                        <span>{item.label}</span>
                      </NavLink>
                    ))}
                  </div>
                </div>
              </div>

              <div className="rr-app-topbar">
                <div className="rr-app-topbar-left">
                  <h2 className="rr-app-title">
                    {loading
                      ? "Preparing Dashboard..."
                      : `Brand Cockpit - ${brandName}`}
                  </h2>

                  <p className="rr-app-subtitle mb-0">
                    {loading
                      ? "Fetching dashboard insights and preparing visualizations"
                      : "Track yearly performance, regional insights, media efficiency and contribution trends"}
                  </p>
                </div>

                <div className="rr-app-topbar-right">
                  {!loading && (
                    <div className="rr-app-topbar-meta">
                      <span className="rr-chip rr-chip-warn">
                        <i className="fas fa-calendar-alt"></i>
                        Previous FY : {previousFY}
                      </span>

                      <span className="rr-chip rr-chip-good">
                        <i className="fas fa-chart-line"></i>
                        Current FY : {currentFY}
                      </span>

                      {dataTillMonth && (
                        <span className="rr-chip rr-chip-info">
                          <i className="fas fa-clock"></i>
                          Data Till : {dataTillMonth}
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="content-area flex-grow-1">
              <Outlet context={{ theme, collapsed, setCollapsed }} />
            </div>
          </div>

          <footer className="rr-app-footer">
            <FooterPages />
          </footer>
        </div>
      </div>

      <ChatBot theme={theme} />
    </>
  );
};

export default IndexPage;
